export enum MedicalNotePinOption {
    SaveCompleteClose = 1,
    SaveComplete,
    SaveClose,
    Save,
    ApproveCompleteClose,
    ApproveComplete,
    ApproveClose,
    Approve
}
